import React, { useContext, useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { RootStoreContext } from '../App';
import { observer } from 'mobx-react';
import Header from '../components/header/Header';
import Dock from '../components/dock/Dock';
import Footer from '../components/footer/Footer';
import CustomCursor from '../components/customCursor/CustomCursor';

import useSessionWatcher from '../hooks/useSessionWatcher';
import useSessionRenewal from '../hooks/useSessionRenewal';

const PrivateRouter = observer(() => {
	const store = useContext(RootStoreContext);

	useEffect(() => {
		const isLogin = store.authStore.isLogin();
		if (
			isLogin &&
			!store.authStore.isLoadingAuth &&
			!store.authStore.auth?.profile
		) {
			store.authStore.loadAuth();
		}
	}, [store.authStore]);

	useSessionWatcher(); // 세션 만료 감지
	// 서버에서 준 token 세션 확인 필요
	// useSessionRenewal(); // 사용자 활동 시 세션 연장

	return store.authStore.isLogin() ? (
		<>
			{/* <CustomCursor /> */}
			<Header />
			<Outlet />
			<Dock />
			<Footer />
		</>
	) : (
		<Navigate to='/login' />
	);
});

export default PrivateRouter;
